// extracted by mini-css-extract-plugin
module.exports = {"root":"Simplify_root__vQTH3","container":"Simplify_container__L1HW7"};